export default {
  
  methods: {

    pie_Summary(selection, title_, data_, x_, y_) {

      let chart = selection
      .append('g')
      .attr('transform', `translate(${x_}, ${y_})`)

      chart
      .append('text')
      .attr('id', `TOTAL_${title_}`)
      .attr('x', 0).attr('y', 0)
      .attr('font-size', 10).attr('fill', '#757575')
      .text(title_)

      chart
      .append('text')
      .attr('x', this.getNode(`#TOTAL_${title_}`) + 3).attr('y', 0)
      .attr('font-size', 12).attr('fill', '#333')
      .text(data_.total)

      chart
      .append('rect')
      .attr('x', 0).attr('y', 2).attr('ry', 5)
      .attr('width', 100).attr('height', 11)
      .attr('fill', '#F4F5F5')

      chart
      .append('rect')
      .attr('x', 0).attr('y', 2).attr('ry', 5)
      .attr('width', data_.prog).attr('height', 11)
      .attr('fill', '#B4E3FA')

      chart
      .append('text')
      .attr('x', data_.prog<60 ? data_.prog+2 : data_.prog-2).attr('y', 11)
      .attr('font-size', 10).attr('fill', '#333').attr('text-anchor', data_.prog<60 ? 'start' : 'end')
      .text(data_.actual)
    },
    


    pie_Detail() {

      let detail = this.radialCanvas
      .append('g')
      .attr('id', `DETAIL`)
      .attr('transform', `translate(0, ${20})`)
      .attr('opacity', 0)

      // System
      detail
      .append('text')
      .attr('x', 25).attr('y', -60).attr('font-size', 11)
      .attr('fill', '#757575').attr('text-anchor', 'end')
      .text(`No. of System`)

      detail
      .append('text')
      .attr('id', `VAL_SYS`)
      .attr('x', 28).attr('y', -60).attr('font-size', 13)
      .attr('fill', '#EC407A')
      .text(123)

      // Sub-System
      detail
      .append('text')
      .attr('x', 25).attr('y', -43).attr('font-size', 11)
      .attr('fill', '#757575').attr('text-anchor', 'end')
      .text(`No. of Sub-System`)

      detail
      .append('text')
      .attr('id', `VAL_SUBSYS`)
      .attr('x', 28).attr('y', -43).attr('font-size', 13)
      .attr('fill', '#44A9DF')
      .text(123)


      let inra = (this.pie.ra * this.pie.inRa) - 10
      detail
      .append('line')
      .attr('x1', -inra).attr('y1', -35.5)
      .attr('x2', inra).attr('y2', -35.5)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      detail
      .append('text')
      .attr('x', 10).attr('y', -20).attr('font-size', 11)
      .attr('fill', '#333').attr('text-anchor', 'end')
      .text(`A ITRs`)

       detail
      .append('text')
      .attr('x', 60).attr('y', -20).attr('font-size', 11)
      .attr('fill', '#333').attr('text-anchor', 'end')
      .text(`A Punch`)

      this.draw_Detail(detail)
    },


    draw_Detail(selection, itr, y=-3) {

      this.detail.cols.forEach(d=> {
        selection
        .append('text')
        .attr('x', -27).attr('y', y).attr('font-size', 11)
        .attr('fill', '#757575').attr('text-anchor', 'end')
        .text(d.name)

        selection
        .append('text')
        .attr('id', `VAL_A_${d.code}`)
        .attr('x', 10).attr('y', y).attr('font-size', 11)
        .attr('fill', '#000').attr('text-anchor', 'end')
        .text((123).toLocaleString('ko-KR'))

        selection
        .append('text')
        .attr('id', `VAL_PA_${d.code}`)
        .attr('x', 60).attr('y', y).attr('font-size', 11)
        .attr('fill', '#000').attr('text-anchor', 'end')
        .text((123).toLocaleString('ko-KR'))

        y += 15
      })
    },
  }
}